import { render, staticRenderFns } from "./ModalComponent.vue?vue&type=template&id=e22cf3e4&scoped=true"
import script from "./ModalComponent.vue?vue&type=script&lang=js"
export * from "./ModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalComponent.vue?vue&type=style&index=0&id=e22cf3e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22cf3e4",
  null
  
)

export default component.exports